import './style.modules.scss'

import { Spacer } from '@ampcore/adel-react'
import { SpacerSpacing } from '@ampcore/adel-react'
import { LinkProps } from '@ampcore/adel-react'
import React from 'react'

import { TwoColumnCardBackgroundColor } from './TwoColumnCardColor.type'
import { TwoColumnCardItem } from './TwoColumnCardItem'

export type CardColumn = {
  superheadline?: string
  heading?: string
  body?: string
  link?: LinkProps
  image?: string
  imageLocation?: 'left' | 'right'
  analyticsName?: string
  backgroundColor?: TwoColumnCardBackgroundColor
  showImageBorder?: boolean
}

export type TwoColumnCardProps = {
  card: CardColumn[]
  componentSpacing?: SpacerSpacing
  testId?: string
}

export const TwoColumnCard = (props: TwoColumnCardProps) => {
  const { card, componentSpacing, testId } = props

  if (!card) {
    return null
  }

  return (
    <Spacer spacing={componentSpacing}>
      {Array.from({ length: Math.ceil(card.length / 2) }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="TwoColumnCard u-flex u-sm-flexCol u-flexJustifyBetween u-margin16 u-sizeConstrained"
        >
          {[0, 1].map(colOffset => {
            const index = rowIndex * 2 + colOffset
            if (index >= card.length) return null
            const cardColumn = card[index]
            return (
              <TwoColumnCardItem
                superheadline={cardColumn.superheadline}
                heading={cardColumn.heading}
                body={cardColumn.body}
                link={cardColumn.link}
                image={cardColumn.image}
                imageLocation={cardColumn.imageLocation}
                analyticsName={cardColumn.analyticsName}
                backgroundColor={cardColumn.backgroundColor}
                showImageBorder={cardColumn.showImageBorder}
                testId={testId ? `${testId}-item-${index}` : undefined}
                key={`card-${index}`}
                className={'TwoColumnCardItem-cardWidth u-size5of12'}
              />
            )
          })}
        </div>
      ))}
    </Spacer>
  )
}
